module.exports = __webpack_public_path__ + "img/nomads_grid_mob.0ee64a07.svg";